var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trimmedText)?_c('div',{staticClass:"jb-report-watermark"},[_c('div',{staticClass:"jb-report-watermark-inner",style:(_vm.innerStyle)},_vm._l((_vm.tileIndices),function(idx){return _c('span',{key:'wm-' + idx,staticClass:"jb-report-watermark-item"},[_vm._v(_vm._s(_vm.displayText))])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e9e2492","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jbReport/JbReportWatermark.vue
// module id = BJkV
// module chunks = 1